  import { useStore } from '../store'

export function isTV() {


const store = useStore.getState()

  if(store?.config?.as_tv){
    return true
  }

  if (localStorage.getItem('isTVEnvironment')) {
    return true
  }
  const ua = navigator.userAgent.toLowerCase()

  // ✅ Explicit Smart TV / Console identifiers
  const tvKeywords = [
    'smart-tv',
    'smarttv',
    'hbbtv',
    'appletv',
    'googletv',
    'netcast',
    'tizen',
    'webos',
    'viera',
    'roku',
    'bravia',
    'aquosbrowser',
    'philips',
    'toshiba',
    'hisense',
    'panasonic',
    'samsungbrowser',
    'lgbrowser',
  ]

  const consoleKeywords = ['playstation', 'xbox', 'nintendo']

  // Strong UA match → definitely a TV/console
  if (tvKeywords.some((k) => ua.includes(k)) || consoleKeywords.some((k) => ua.includes(k))) {
    return true
  }

  // ✅ Heuristic fallback: only when UA is generic
  const { width, height } = window.screen
  const diagonalInches = Math.sqrt(width ** 2 + height ** 2) / (window.devicePixelRatio * 96)

  // Require BOTH very large size and *no touch* for fallback
  if (diagonalInches > 40 && !('ontouchstart' in window)) {
    return true
  }

  // Otherwise → treat as non-TV
  return false
}
